import { createSelector } from '@reduxjs/toolkit'
import { Slice, PostByTagSlice, PostByTagElement } from './types'

export const getPostsByTagObject = (tag: string, postsByTag: PostByTagSlice): PostByTagElement | undefined => {
  if (!postsByTag) {
    return
  }

  const { isFetching, isSuccess, isFailure, payload } = postsByTag
  const isFirstLoad = !payload

  return {
    isFirstLoad,
    isFetching,
    isSuccess,
    isFailure,
    tag,
    postSlugs: payload
  }
}

export const getPostByTag = (tag: string) => createSelector(
  (state: any) => state.blog.postsByTag,
  (postsByTag: Slice) => getPostsByTagObject(tag, postsByTag[tag])
)
